export const unreadMessagesCount = state => state.messages.main.length
export const unreadNotificationsCount = state => state.notifications.main.length
export const remainTasksCount = state => state.tasks.main.length
export const currentUser = state => state.user.main
export const totalProduct = state => state.products.main
export const profile = state => state.profile.main
export const perfil = state => state.perfil.main

export const carrinho = state => state.carrinho.main

export const produtosSelecionados = state => state.produtosSelecionados.main

export const produtoAtivo = state => state.produtoAtivo.main

export const pizzaAtiva = state => state.pizzaAtiva.main

export const cloneAtivo = state => state.cloneAtivo.main

export const enderecoAtivo = state => state.enderecoAtivo.main

export const modalAddCarrinho = state => state.modalAddCarrinho.main

export const modals = state => state.modals.main
